import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { CancellationToken } from '@cian/http-api';
import { MaxRetryExceededError } from '../maxRetryExceededError';
import { ERepeatPolicy, ERequestStatus } from './constants';
import { Defer } from '../defer';
import { RequestCancelError } from '../requestCancelError';
export var RepeatableRequest = /*#__PURE__*/function () {
  function RepeatableRequest(_ref) {
    var repeatInterval = _ref.repeatInterval,
      maxRepeatInterval = _ref.maxRepeatInterval,
      maxRepeatCount = _ref.maxRepeatCount,
      repeatPolicy = _ref.repeatPolicy;
    _classCallCheck(this, RepeatableRequest);
    _defineProperty(this, "cancellationToken", void 0);
    _defineProperty(this, "repeatInterval", void 0);
    _defineProperty(this, "maxRepeatCount", void 0);
    _defineProperty(this, "maxRepeatInterval", void 0);
    _defineProperty(this, "deferred", void 0);
    _defineProperty(this, "repeatPolicy", void 0);
    _defineProperty(this, "status", ERequestStatus.Init);
    _defineProperty(this, "retryCount", 0);
    _defineProperty(this, "retryIntervalId", void 0);
    this.cancellationToken = new CancellationToken();
    this.maxRepeatInterval = maxRepeatInterval;
    this.maxRepeatCount = maxRepeatCount;
    this.repeatInterval = repeatInterval;
    this.repeatPolicy = repeatPolicy;
    this.deferred = new Defer();
  }
  return _createClass(RepeatableRequest, [{
    key: "isFinished",
    get: function get() {
      return this.status === ERequestStatus.Complete;
    }
  }, {
    key: "isPending",
    get: function get() {
      return this.status === ERequestStatus.Pending;
    }
  }, {
    key: "isCanceled",
    get: function get() {
      return this.cancellationToken.isCanceled();
    }
  }, {
    key: "isRepeatExceeded",
    get: function get() {
      return this.maxRepeatCount && this.retryCount >= this.maxRepeatCount;
    }
  }, {
    key: "cancel",
    value: function cancel() {
      clearTimeout(this.retryIntervalId);
      this.cancellationToken.cancel();
      this.deferred.reject(new RequestCancelError({
        message: 'Request canceled',
        domain: 'RepeatableRequest.Cancel'
      }));
      this.markComplete();
      return this.deferred.promise;
    }
  }, {
    key: "start",
    value: function start(request, onError) {
      if (this.isPending || this.isFinished) {
        throw new Error('Нельзя повторно запустить процесс');
      }
      this.markPending();
      this.performRequest(request, onError);
      return this.deferred.promise;
    }
  }, {
    key: "performRequest",
    value: function () {
      var _performRequest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(request, onError) {
        var result;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return request(this.cancellationToken);
            case 3:
              result = _context.sent;
              if (!this.isCanceled) {
                _context.next = 6;
                break;
              }
              return _context.abrupt("return");
            case 6:
              if (!(this.repeatPolicy === ERepeatPolicy.Always && !this.isRepeatExceeded)) {
                _context.next = 8;
                break;
              }
              return _context.abrupt("return", this.scheduleNextRequest(request, onError));
            case 8:
              this.markComplete();
              this.deferred.resolve(result);
              _context.next = 22;
              break;
            case 12:
              _context.prev = 12;
              _context.t0 = _context["catch"](0);
              if (!this.isCanceled) {
                _context.next = 16;
                break;
              }
              return _context.abrupt("return");
            case 16:
              if (!this.isRepeatExceeded) {
                _context.next = 20;
                break;
              }
              this.markComplete();
              this.deferred.reject(new MaxRetryExceededError({
                message: 'Request canceled',
                domain: 'RepeatableRequest.PerformRequest'
              }));
              return _context.abrupt("return");
            case 20:
              onError(_context.t0);

              /* Планируем следующий запрос */
              return _context.abrupt("return", this.scheduleNextRequest(request, onError));
            case 22:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[0, 12]]);
      }));
      function performRequest(_x, _x2) {
        return _performRequest.apply(this, arguments);
      }
      return performRequest;
    }()
  }, {
    key: "scheduleNextRequest",
    value: function scheduleNextRequest(request, onError) {
      var _this = this;
      this.retryCount++;
      this.retryIntervalId = setTimeout(function () {
        return _this.performRequest(request, onError);
      }, Math.min(this.maxRepeatInterval, this.repeatInterval * this.retryCount));
    }
  }, {
    key: "markComplete",
    value: function markComplete() {
      this.status = ERequestStatus.Complete;
    }
  }, {
    key: "markPending",
    value: function markPending() {
      this.status = ERequestStatus.Pending;
    }
  }]);
}();